module.exports = __webpack_public_path__ + "static/media/fig_1.c3fa78c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/rezum/fig_1.png
// module id = 612
// module chunks = 0